import React, { FunctionComponent } from 'react'
import { Col,FormLabel, Form, Row } from 'react-bootstrap'
import PropTypes,{InferProps} from 'prop-types'
import { SankeyDataPropTypes, SankeyLink } from './types'
import { toPrecision } from 'open-sankey/dist/SankeyUtils'

const SankeyUncertPropTypes = {
  sankey_data: PropTypes.shape(SankeyDataPropTypes).isRequired,
  set_sankey_data: PropTypes.func.isRequired
}

export const uncert_link_color = (
  l : SankeyLink,
  value_index: number
) => {
  if (l.maxi === undefined || l.mini === undefined || l.maxi === null || l.mini === null) {
    return l.color
  }
  const p = (l.maxi[value_index] - l.mini[value_index])/l.value[value_index]
  if (p <= 0.1) {
    return '#e6d5b8'
  } else if (p <= 0.25) {
    return '#f0a500'
  } else if (p <= 0.5) {
    return '#e45826'
  } else {
    return '#4a3933'
  }  
}

export const uncert_node_color = () => {
  return 'grey'
}

export const uncert_link_text = (
  l: SankeyLink,
  link_value: number,
  display_style: { font_size?: string; filter?: number; filter_label?: number; unit?: boolean },
  value_index : number
) => {
  let unit_name = ''
  let the_link_value = toPrecision(link_value)
  if ( display_style.unit ) {
    if ( l.natural_unit ) {
      unit_name = l.natural_unit.replace('k tonnes','kt').replace('k tonne','kt')
      the_link_value = toPrecision(link_value * (l.conv ? l.conv[1] : 1) )
    }
  }
  if (l.maxi === undefined || l.mini === undefined || l.maxi === null || l.mini === null) {
    return the_link_value + unit_name
  }
  if ( display_style.unit && l.conv ) {
    const mini = Math.round(l.conv[1]*l.mini[value_index])
    const maxi = Math.round(l.conv[1]*l.maxi[value_index])
    return '['+mini+' '+maxi+']' + ' ' + unit_name
  }

  if (l.mini[value_index] === l.maxi[value_index]) {
    return l.mini[value_index] + ' ' + unit_name
  }

  return '[' + l.mini[value_index] + ' ' + l.maxi[value_index] + ']' + unit_name
}

type SankeyAppTypes = InferProps<typeof SankeyUncertPropTypes>

const SankeyUncert : FunctionComponent<SankeyAppTypes> = ({sankey_data,set_sankey_data}) => {
  return (
    <Form.Group as={Col} style={{marginLeft : '30px', width: '100px'}}>
      <Row>
        <FormLabel className="text-center" >Valeurs visualisées</FormLabel> 
      </Row>   
      <Row>    
        <Form.Select  onChange={(evt : React.ChangeEvent<HTMLSelectElement>) => {
          sankey_data.show_uncert = evt.target.value === 'uncert'
          if (sankey_data.show_uncert) {
            sankey_data.tags_catalog['Uncert'].show_legend = true
          } else {
            sankey_data.tags_catalog['Uncert'].show_legend = false            
          }
          set_sankey_data({...sankey_data})
        }}>
          <option key={0} value='average' selected={ sankey_data.show_uncert !== true}>Moyennes</option>
          <option key={1} value='uncert' selected={ sankey_data.show_uncert === true}>Incertitudes</option>
        </Form.Select>
      </Row>
    </Form.Group>
  )
}

SankeyUncert.propTypes = SankeyUncertPropTypes

export default SankeyUncert